import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_BO_DEMO_ILO1 = {
  title: "Prediction of probability of\nmilestone getting missed",
  subtitle: "Business Operations Demo",
  text: "Faster resolutions with less errors.",
  label: { iconPath: "start.png", text: "ILO AI" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_112"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_110"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO1/ILO1_demo_screens_base.png",
  rightSideVideo: "ILO/ILO1/INF_CMT_827.23_Business Demo_Part 8_R1.mp4",
  pageNumber: "ILO_111",
};

export default DATA_BO_DEMO_ILO1;
